import { faArrowLeft, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import ProcessLoading from "../components/processLoading";
import logo from "../assets/logo.png";
import "../styles/authentification.css";

const VerificationToken = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || "";

  const [formData, setFormData] = useState({
    token: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [modalState, setModalState] = useState({
    show: false,
    loading: false,
    success: false,
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Vérification que les mots de passe correspondent
    if (formData.newPassword !== formData.confirmPassword) {
      setModalState({
        show: true,
        loading: false,
        success: false,
        message: "Les mots de passe ne correspondent pas",
      });
      return;
    }

    // Vérification des exigences du mot de passe (selon backend)
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/;
    if (!passwordRegex.test(formData.newPassword)) {
      setModalState({
        show: true,
        loading: false,
        success: false,
        message: "Le mot de passe doit contenir au moins 8 caractères, une majuscule et un chiffre",
      });
      return;
    }

    setModalState({
      show: true,
      loading: true,
      success: false,
      message: "Réinitialisation du mot de passe en cours...",
    });

    try {
      const response = await fetch("http://localhost:4000/api/client/reset", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: formData.token,
          newPassword: formData.newPassword,
          confirmPassword: formData.confirmPassword, // Ajouté pour correspondre au backend
        }),
      });

      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(errorMessage || "Erreur lors de la réinitialisation");
      }

      // Vérifier le Content-Type de la réponse
      const contentType = response.headers.get("content-type");
      let data;
      
      if (contentType && contentType.includes("application/json")) {
        data = await response.json();
      } else {
        data = await response.text();
      }

      setModalState({
        show: true,
        loading: false,
        success: true,
        message: "Mot de passe réinitialisé avec succès ! Redirection vers la connexion...",
      });

      setTimeout(() => {
        navigate("/");
      }, 2000);

    } catch (error) {
      console.error("Erreur:", error.message);
      setModalState({
        show: true,
        loading: false,
        success: false,
        message: `Erreur : ${error.message}`,
      });
    }
  };

  const closeModal = () => {
    setModalState((prev) => ({ ...prev, show: false }));
  };

  return (
    <div className="container-partenariat container-fluid p-0">
      <div className="row g-0 min-vh-100">
        {/* Section Gauche - Formulaire */}
        <div className="col-lg-6 d-flex align-items-center p-5 light-Mode">
          <div className="w-100">
            <Link to="/reinitialisation">
              <FontAwesomeIcon icon={faArrowLeft} width={"50px"} />
            </Link>
            <h1
              className="mb-3"
              style={{ textAlign: "center", fontWeight: "lighter" }}
            >
              <strong style={{ color: "#0d6efd" }}>Nouveau</strong> mot de passe
            </h1>
            <p className="text-center text-muted mb-4">
              Entrez le code reçu par email et votre nouveau mot de passe
            </p>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="token" className="form-label">
                  Code de vérification
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="token"
                  name="token"
                  value={formData.token}
                  onChange={handleChange}
                  placeholder="Entrez le code reçu par email"
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="newPassword" className="form-label">
                  Nouveau mot de passe
                </label>
                <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    id="newPassword"
                    name="newPassword"
                    value={formData.newPassword}
                    onChange={handleChange}
                    placeholder="Min. 8 caractères, 1 majuscule, 1 chiffre"
                    required
                    style={{ borderRight: "none" }}
                  />
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={togglePasswordVisibility}
                    style={{
                      borderLeft: "none",
                      backgroundColor: "white",
                      borderColor: "#ced4da"
                    }}
                  >
                    <FontAwesomeIcon 
                      icon={showPassword ? faEyeSlash : faEye} 
                      style={{ color: "#6c757d" }}
                    />
                  </button>
                </div>
              </div>

              <div className="mb-3">
                <label htmlFor="confirmPassword" className="form-label">
                  Confirmer le mot de passe
                </label>
                <div className="input-group">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-control"
                    id="confirmPassword"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    placeholder="Retapez le mot de passe"
                    required
                    style={{ borderRight: "none" }}
                  />
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={toggleConfirmPasswordVisibility}
                    style={{
                      borderLeft: "none",
                      backgroundColor: "white",
                      borderColor: "#ced4da"
                    }}
                  >
                    <FontAwesomeIcon 
                      icon={showConfirmPassword ? faEyeSlash : faEye} 
                      style={{ color: "#6c757d" }}
                    />
                  </button>
                </div>
              </div>

              <br />
              <button
                type="submit"
                className="btn w-100 py-3 mb-3 hover-primary"
                disabled={modalState.loading}
              >
                {modalState.loading ? "Réinitialisation..." : "Réinitialiser le mot de passe"}
              </button>

              <div className="text-center mt-3">
                <Link to="/" className="text-decoration-none">
                  Retour à la connexion
                </Link>
              </div>
            </form>
          </div>
        </div>

        {/* Section Droite */}
        <div className="col-lg-6 section-etude-cas">
          <div className="superposition-etude p-5 d-flex flex-column justify-content-between h-100">
            <div style={{ margin: "0 auto", marginTop: "40px" }}>
              <img
                src={logo}
                alt="logo transfo africa"
                style={{ width: "200px", height: "100px" }}
              />
            </div>
            <div>
              <blockquote className="citation mb-5" style={{ marginTop: "-20px" }}>
                <p className="mb-0 fs-3">
                  <strong style={{ color: "#0d6efd" }}>Transfo Africa</strong>{" "}
                  est une entreprise exerçant exclusivement dans le secteur des
                  nouvelles technologies de l'information. Nous vous proposons
                  des services tels que la sécurité des systèmes informatiques et
                  réseaux, le développement d'applications web et mobile et les
                  solutions cloud.
                </p>
              </blockquote>
            </div>
          </div>
        </div>
      </div>

      {/* Modal de chargement */}
      <ProcessLoading
        show={modalState.show}
        loading={modalState.loading}
        success={modalState.success}
        message={modalState.message}
        onClose={closeModal}
        autoCloseDelay={modalState.success ? 2000 : 3000}
        onAutoClose={closeModal}
      />
    </div>
  );
};

export default VerificationToken;